// import matrix from '../__customize__/matrix/index.vue';

export default {
  // matrix: {
  //   component: matrix,
  // },
};
